import React, { useState } from 'react';
import BulkUpload from './bulkUpload';
import Search from './search';
import BatchDetails from './batchDetails';
import PortfolioDetails from './portfolioDetails';
import httpClient from 'httpClient';

const BulkRisks = (props) => {
  const [view, setView] = useState(0);

  const onUploadSuccess = async (key, batchName) => {
    // fileUploadCloseAsync();
    const response = await httpClient.get(`/risk/v1/getUploadedBulkFileData?key=${key}&batchName=${batchName}`);
    console.log(response);
    setView(1);
  }

  return (
    <div>
       <div className='flex'>
          <div className='w-1/2 mr-5 border-uhblue border rounded-3xl pb-5 pt-7 px-10 bg-gr00'>
            <BulkUpload
              onUploadSuccess={onUploadSuccess}
            />
          </div>
          <div className='w-1/2 mr-5 border-uhblue border rounded-3xl pb-5 pt-7 px-10'>
            <Search/>
          </div>
          
       </div>
       <div>
          {
            view===1 && <BatchDetails/>
          }
          {
            view===2 && <PortfolioDetails/>
          }
       </div>
    </div>
  ) 
}

export default BulkRisks;